import { render, staticRenderFns } from "./HistoricalEnquiryModal.vue?vue&type=template&id=2cb74176&scoped=true"
import script from "./HistoricalEnquiryModal.vue?vue&type=script&lang=js"
export * from "./HistoricalEnquiryModal.vue?vue&type=script&lang=js"
import style0 from "./HistoricalEnquiryModal.vue?vue&type=style&index=0&id=2cb74176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb74176",
  null
  
)

export default component.exports